import { render, staticRenderFns } from "./CreateDisk.vue?vue&type=template&id=8e3ceb4c"
import script from "./CreateDisk.vue?vue&type=script&lang=js"
export * from "./CreateDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports